import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=e6ff1c50&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=e6ff1c50&prod&lang=scss&scoped=true"
import style1 from "./basicInfo.vue?vue&type=style&index=1&id=e6ff1c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ff1c50",
  null
  
)

export default component.exports